import ArchiveGrid from '@/components/sections/archive-grid'
import AsymmetricPush from '@/components/sections/asymmetric-push'
import Awards from '@/components/sections/awards'
import BookPush from '@/components/sections/book-push'
import Contacts from '@/components/sections/contacts'
import DoubleMedia from '@/components/sections/double-media'
import DoubleParagraph from '@/components/sections/double-paragraph'
import DoublePush from '@/components/sections/double-push'
import Hero from '@/components/sections/hero'
import HeroParagraph from '@/components/sections/hero-paragraph'
import ImageText from '@/components/sections/image-text'
import MediaGallery from '@/components/sections/media-gallery'
import Menu from '@/components/sections/menu'
import SingleMedia from '@/components/sections/single-media'
import SingleParagraph from '@/components/sections/single-paragraph'
import Spacer from '@/components/sections/spacer'
import TheForkWidget from '@/components/sections/thefork-widget'
import Timeline from '@/components/sections/timeline'

export const sectionsMap: any = {
  'archive-grid': ArchiveGrid,
  'asymmetric-push': AsymmetricPush,
  awards: Awards,
  'book-push': BookPush,
  contacts: Contacts,
  'double-media': DoubleMedia,
  'double-paragraph': DoubleParagraph,
  'double-push': DoublePush,
  hero: Hero,
  'hero-paragraph': HeroParagraph,
  'image-text': ImageText,
  'media-gallery': MediaGallery,
  menu: Menu,
  'single-media': SingleMedia,
  'single-paragraph': SingleParagraph,
  spacer: Spacer,
  'thefork-widget': TheForkWidget,
  timeline: Timeline
}
